module.exports = __webpack_public_path__ + "img/fengcai6.ff7a8ce8.png";